var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"order_link--default",class:_vm.cls,on:{"click":function($event){$event.stopPropagation();return _vm.click($event)}}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }